import * as classnames from 'classnames'
import get from 'lodash-es/get'
import head from 'lodash-es/head'
import * as React from 'react'

import { IItem } from '../../../typings/searchResults'

import * as styles from './imagePreview.module.css'

const landscapePreviewUrl = (previews: IItem['previews']) => {
  const urls =
    get(previews, 'landscape_preview.image_urls') ||
    get(previews, 'icon_with_video_preview.image_urls') ||
    get(previews, 'icon_with_landscape_preview.image_urls') ||
    []

  return get(head(urls), 'url')
}

const squarePreviewUrl = (previews: IItem['previews']) => {
  const urls =
    get(previews, 'icon_with_square_preview.image_urls') ||
    get(previews, 'landscape_preview.image_urls') ||
    get(previews, 'icon_with_landscape_preview.image_urls') ||
    []

  return get(head(urls), 'url')
}

const getMarketingImg = (previews: IItem['previews']): any =>
  get(previews, 'landscape_preview.landscape_url') ||
  get(previews, 'icon_with_video_preview.landscape_url') ||
  get(previews, 'icon_with_landscape_preview.landscape_url') ||
  get(previews, 'icon_with_square_preview.square_url')

const getImgixImg = (previews: IItem['previews']): any =>
  squarePreviewUrl(previews) ||
  landscapePreviewUrl(previews) ||
  getMarketingImg(previews)

const ImagePreview = ({
  alt,
  className,
  previews,
  title
}: {
  alt: string
  className?: string
  previews: IItem['previews']
  title?: string
}) => {
  const imageClass = classnames(
    className,
    styles.preview,
    'preload no_preview landscape-image-magnifier'
  )

  let fallbackUsed = false

  return (
    <img
      alt={alt}
      className={imageClass}
      src={getImgixImg(previews)}
      title={title || alt}
      onError={(e: any): void => {
        if (!fallbackUsed) {
          fallbackUsed = true
          e.target.src = getMarketingImg(previews)
        }
      }}
    />
  )
}

export default ImagePreview
